module.exports = __webpack_public_path__ + "static/marlos_urnrayle-1520b871c554794e223d0a2e2e8f3581.jpeg";